import React, { useEffect } from 'react';
import './styles/App.css';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import { EntraAuthProvider } from './components/EntraAuth/EntraAuthProvider';
import { EntraConfigChecker } from './components/EntraAuth';
import { Card } from './components/ui';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Specializari from './pages/Specialitati';
import SpecialitatiNew from './pages/SpecialitatiNew';
import Header from './pages/Header';
import ProgramariNew from './pages/ProgramariNew';
import Medici from './pages/Medici';
import MediciNew from './pages/MediciNew';
import DoctorAdmin from './pages/DoctorAdmin';
import Login from './pages/Login';
import LoginNew from './pages/login-new';
import LoginEntra from './pages/LoginEntra';
import DespreNoi from './pages/DespreNoi';
import Articole from './pages/Articole';
import ContulMeu from './pages/ContulMeu';
import TermeniSiConditii from './pages/TermeniSiConditii';
import PoliticaConfidentialitate from './pages/PoliticaConfidentialitate';
import PoliticaCookies from './pages/PoliticaCookies';
import GDPR from './pages/GDPR';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PageTitle from './components/PageTitle';
import TopHeader from './components/TopHeader';
import PersistentOverlayManager from './components/PersistentOverlayManager';

function OptionCard({ to, icon, label }) {
  const isExternal = to.startsWith('http');
  const LinkComponent = isExternal ? 'a' : Link;
  const linkProps = isExternal ? { href: to, target: '_blank', rel: 'noopener noreferrer' } : { to };

  return (
    <LinkComponent {...linkProps} style={{ textDecoration: 'none' }}>
      <Card
        variant="interactive"
        style={{
          textAlign: 'center',
          minHeight: '160px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'var(--color-primary)',
          fontWeight: '600',
          fontSize: 'var(--font-size-lg)',
          padding: 'var(--spacing-xl)',
          transition: 'all 0.3s ease',
          border: '1px solid #e0e0e0'
        }}
      >
        <div style={{
          fontSize: '3rem',
          marginBottom: 'var(--spacing-lg)',
          opacity: '0.8'
        }}>
          {icon}
        </div>
        <span style={{
          color: 'var(--color-text-primary)',
          fontWeight: '600'
        }}>
          {label}
        </span>
      </Card>
    </LinkComponent>
  );
}

function Landing() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'var(--color-background)',
      fontFamily: 'var(--font-family-primary)'
    }}>
      <TopHeader />
      <Header />
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        fontSize: '2rem',
        fontWeight: 'bold',
        color: 'var(--color-primary)'
      }}>
        În curând
      </div>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title" style={{ color: '#006666' }}>
            Îngrijire medicală modernă,<br />
            <span className="hero-highlight" style={{ color: '#006666' }}>la îndemână</span>
          </h1>
          <p className="hero-description" style={{ color: '#006666' }}>
            Acces ușor la servicii medicale de calitate, programări online 24/7,
            și o echipă dedicată sănătății tale. Fără așteptări lungi, cu grijă personalizată.
          </p>
          <div className="hero-actions">
            <Link to="/programari" className="cta-button primary">
              Programează-te acum
            </Link>
            <Link to="/specializari" className="cta-button secondary">
              Vezi specializările
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="trust-section ob-is-breaking-bad">
        <div className="trust-container">
          <div className="trust-item">
            <div className="trust-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3>Programări rapide</h3>
            <p>Online în doar câteva minute</p>
          </div>
          <div className="trust-item">
            <div className="trust-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
              </svg>
            </div>
            <h3>Medici experți</h3>
            <p>Echipă calificată și dedicată</p>
          </div>
          <div className="trust-item">
            <div className="trust-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3>Siguranță garantată</h3>
            <p>Protecție și confidențialitate</p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="services-container">
          <h2 className="section-title">Serviciile noastre</h2>
          <p className="section-description">
            Acces rapid la toate specialitățile medicale de care ai nevoie
          </p>
          <div className="services-grid">
            <OptionCard to="/specializari" icon={
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L19 7L14.74 11.26L21 12L14.74 12.74L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12.74L3 12L9.26 11.26L5 7L10.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 8C13.6569 8 15 6.65685 15 5C15 3.34315 13.6569 2 12 2C10.3431 2 9 3.34315 9 5C9 6.65685 10.3431 8 12 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 12C9.65685 12 11 10.6569 11 9C11 7.34315 9.65685 6 8 6C6.34315 6 5 7.34315 5 9C5 10.6569 6.34315 12 8 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 12C17.6569 12 19 10.6569 19 9C19 7.34315 17.6569 6 16 6C14.3431 6 13 7.34315 13 9C13 10.6569 14.3431 12 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            } label="Specializări medicale" />
            <OptionCard to="/programari" icon={
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2" />
                <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" />
                <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" />
                <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2" />
                <line x1="9" y1="14" x2="15" y2="14" stroke="currentColor" strokeWidth="2" />
                <line x1="9" y1="18" x2="15" y2="18" stroke="currentColor" strokeWidth="2" />
              </svg>
            } label="Programare online" />
            <OptionCard to="/medici" icon={
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
                <path d="M12 11V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            } label="Echipa medicală" />
          </div>
        </div>
      </section>

      {/* Clinic Images Carousel */}
      <section className="clinic-gallery-section">
        <div className="clinic-gallery-container">
          <h2 className="section-title clinic-gallery-title">Clinica Evoo Medical</h2>
          <p className="section-description clinic-gallery-description">
          </p>
          <div className="clinic-carousel-wrapper">
            <Swiper
              slidesPerView={2}
              spaceBetween={20}
              navigation={true}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              speed={500}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              modules={[Autoplay, Navigation, Pagination]}
              className="clinic-carousel"
            >
              <SwiperSlide>
                <img
                  src="https://images.pexels.com/photos/4386466/pexels-photo-4386466.jpeg"
                  alt="Modern hospital lobby"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://images.pexels.com/photos/3845129/pexels-photo-3845129.jpeg"
                  alt="Medical team consultation"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://images.pexels.com/photos/5653334/pexels-photo-5653334.jpeg"
                  alt="Hospital reception desk"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://images.pexels.com/photos/325229/pexels-photo-325229.jpeg"
                  alt="Medical laboratory equipment"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://images.pexels.com/photos/40568/medical-appointment-doctor-healthcare-40568.jpeg"
                  alt="Doctor examining patient"
                />
              </SwiperSlide>

            </Swiper>
          </div>
        </div>
      </section>

      {/* Google Reviews Section - Hidden */}
      {/*
      <section className="google-reviews-section">
        <div className="google-reviews-container">
          <h2 className="section-title">Recenzii Google</h2>
          <p className="section-description">
            Vezi ce spun pacienții noștri despre experiența lor la Evoo Medical
          </p>
          <div className="reviews-grid">
            <div className="review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <div className="reviewer-avatar">👤</div>
                  <div>
                    <div className="reviewer-name">Maria Popescu</div>
                    <div className="review-stars">⭐⭐⭐⭐⭐</div>
                  </div>
                </div>
                <div className="review-date">2 luni în urmă</div>
              </div>
              <p className="review-text">
                Excelent serviciu medical! Personalul este foarte prietenos și profesionist. Așteptările au fost scurte și tratamentul a fost eficient.
              </p>
            </div>

            <div className="review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <div className="reviewer-avatar">👤</div>
                  <div>
                    <div className="reviewer-name">Ion Ionescu</div>
                    <div className="review-stars">⭐⭐⭐⭐⭐</div>
                  </div>
                </div>
                <div className="review-date">1 săptămână în urmă</div>
              </div>
              <p className="review-text">
                Clinica are echipamente moderne și medicii sunt foarte bine pregătiți. Recomand tuturor prietenilor mei pentru servicii medicale de calitate.
              </p>
            </div>

            <div className="review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <div className="reviewer-avatar">👤</div>
                  <div>
                    <div className="reviewer-name">Elena Vasile</div>
                    <div className="review-stars">⭐⭐⭐⭐⭐</div>
                  </div>
                </div>
                <div className="review-date">3 săptămâni în urmă</div>
              </div>
              <p className="review-text">
                Programare online simplă și rapidă. Consultatia a decurs bine, doctorul a explicat totul clar. Mulțumesc pentru grija față de pacienți!
              </p>
            </div>
          </div>
        </div>
      </section>
      */}

      <Footer />
    </div>
  );
}

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Safely track page views with Google Analytics if available
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: location.pathname + location.search,
        });
      }
    } catch (error) {
      // Silently ignore GA tracking errors (e.g., blocked by ad blocker)
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <EntraAuthProvider>
      <div className="App">
        <EntraConfigChecker />
        <PersistentOverlayManager />
        <Router>
          <ScrollToTop />
          <RouteTracker />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <PageTitle title="Acasă" />
                  <Landing />
                </>
              }
            />
            <Route
              path="/login"
              element={
                <>
                  <PageTitle title="Autentificare" />
                  <TopHeader />
                  <Header />
                  <Login />
                  <Footer />
                </>
              }
            />
            <Route
              path="/login-new"
              element={
                <>
                  <PageTitle title="Autentificare Nouă (Entra ID Test)" />
                  <TopHeader />
                  <Header />
                  <LoginNew />
                  <Footer />
                </>
              }
            />
            <Route
              path="/login-entra"
              element={
                <>
                  <PageTitle title="Microsoft Entra ID Login" />
                  <LoginEntra />
                </>
              }
            />
            {/* Redirect from loginentra (without hyphen) to login-entra */}
            <Route
              path="/loginentra"
              element={<Navigate to="/login-entra" replace />}
            />
            <Route
              path="/despre-noi"
              element={
                <>
                  <PageTitle title="Despre noi" />
                  <TopHeader />
                  <Header />
                  <DespreNoi />
                  <Footer />
                </>
              }
            />
            <Route
              path="/specializari"
              element={
                <>
                  <PageTitle title="Specializări Medicale" />
                  <TopHeader />
                  <Header />
                  <Specializari />
                  <Footer />
                </>
              }
            />
            <Route
              path="/specializari-new"
              element={
                <>
                  <PageTitle title="Specializări Medicale (SPS)" />
                  <TopHeader />
                  <Header />
                  <SpecialitatiNew />
                  <Footer />
                </>
              }
            />
            <Route
              path="/programari"
              element={
                <>
                  <PageTitle title="Programare Online" />
                  <TopHeader />
                  <Header />
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '80vh',
                    fontSize: '3rem',
                    fontWeight: 'bold'
                  }}>
                    În curând
                  </div>
                  <Footer />
                </>
              }
            />
            <Route
              path="/programari-test"
              element={
                <>
                  <PageTitle title="Programare Online (Test)" />
                  <TopHeader />
                  <Header />
                  <ProgramariNew />
                  <Footer />
                </>
              }
            />
            {/* Redirect old /programare URL to /programari-test for backward compatibility */}
            <Route
              path="/programare"
              element={<Navigate to="/programari-test" replace />}
            />
            <Route
              path="/programari-new"
              element={
                <>
                  <PageTitle title="Programări Noi (SPS)" />
                  <TopHeader />
                  <Header />
                  <ProgramariNew />
                  <Footer />
                </>
              }
            />
            <Route
              path="/medici"
              element={
                <>
                  <PageTitle title="Echipa Medicală" />
                  <TopHeader />
                  <Header />
                  <Medici />
                  <Footer />
                </>
              }
            />
            <Route
              path="/medici-new"
              element={
                <>
                  <PageTitle title="Program Medici Disponibili (SPS)" />
                  <TopHeader />
                  <Header />
                  <MediciNew />
                  <Footer />
                </>
              }
            />
            <Route
              path="/doctor-admin"
              element={
                <>
                  <PageTitle title="Panou Doctor" />
                  <TopHeader />
                  <Header />
                  <DoctorAdmin />
                  <Footer />
                </>
              }
            />
            <Route
              path="/articole"
              element={
                <>
                  <PageTitle title="Articole" />
                  <TopHeader />
                  <Header />
                  <Articole />
                  <Footer />
                </>
              }
            />
            <Route
              path="/contul-meu"
              element={
                <>
                  <PageTitle title="Contul meu" />
                  <TopHeader />
                  <Header />
                  <ContulMeu />
                  <Footer />
                </>
              }
            />
            <Route
              path="/termeni-si-conditii"
              element={
                <>
                  <PageTitle title="Termeni și Condiții" />
                  <TopHeader />
                  <Header />
                  <TermeniSiConditii />
                  <Footer />
                </>
              }
            />
            <Route
              path="/politica-de-confidentialitate"
              element={
                <>
                  <PageTitle title="Politica de Confidențialitate" />
                  <TopHeader />
                  <Header />
                  <PoliticaConfidentialitate />
                  <Footer />
                </>
              }
            />
            <Route
              path="/politica-de-cookies"
              element={
                <>
                  <PageTitle title="Politica de Cookies" />
                  <TopHeader />
                  <Header />
                  <PoliticaCookies />
                  <Footer />
                </>
              }
            />
            <Route
              path="/gdpr"
              element={
                <>
                  <PageTitle title="Informații GDPR" />
                  <TopHeader />
                  <Header />
                  <GDPR />
                  <Footer />
                </>
              }
            />
          </Routes>
        </Router>
      </div>
    </EntraAuthProvider>
  );
}

export default App;
